module.exports = __webpack_public_path__ + "assets/img/none.629bcaff.png";